module.exports = __webpack_public_path__ + "media/images/components/base/container/gradient-hero-banner-desktop-46a4113be3830e4001a0b292b1bf7f74.jpg";